import request from '../utils/request'
export const Text = params => request({
  url: '/api/users/download/1',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem("Token-Circus") }
})

